import React from 'react';
import LanguageButtonDPC from "./dpc-language-button-iononrischio";
import LogoSVG from "../../img/INR_Logo_FondoBianco_1.svg";
import NavbarDPC from "./dpc-navbar-iononrischio";
import SvgIconDPC from "../dpc-svg-icon-iononrischio";
import {buildMenu} from "../../js/shared-functions";
import {navigate} from "@reach/router";
import GoogleAnalytics from './dpc-googleAnalytics';
import GoogleTagManager from './dpc-googleTagManager';

export default class DpcNavbarIoNonRischio extends React.Component {

    constructor(props) {
        super(props);
        this.state = {value: ''};
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleSubmit(event) {
        
        event.persist();
        event.preventDefault();
        const path = `/${this.props.lang}/risultati-ricerca/`;
        navigate(path, {
                state: {search: this.state.value},
                replace: false
            }
        )
        //this.setState({redirect: true})
    }

    handleInputChange(event) {
        event.persist();
        this.setState({value: event.target.value});
    }

    getMenu = (menuItems) => {
        return this.props.subdomain
            ? buildMenu(menuItems, this.props.lang, this.props.env, this.props.basePathNavbar, this.props.contenutoId, this.props.minisiti)
            : buildMenu(menuItems, this.props.lang, this.props.env, null, this.props.contenutoId, this.props.minisiti)
    };

    getHomePath = () => {
        if (this.props.subdomain) {
            return `${this.props.basePathNavbar}/${this.props.lang}/`
        } else {
            return `/${this.props.lang}/`
        }
    }

    getMinisitoUrl = () => {
        var subdomain = "";
        if(this.props.lang === 'it'){
            subdomain = this.props.subdomain;
        }else{
            subdomain = this.getLabel(this.props.subdomain);
        }
        return this.props.minisiti[`MINISITO_${subdomain.toUpperCase().replace(new RegExp("[\\s-]+", "g"), '_')}_URL`]
    }

    getLabel = (subdomain) => {
        switch(subdomain){
            case process.env.MINISITO_EMERGENZE_LABEL_EN:
                return process.env.MINISITO_EMERGENZE_LABEL;
            case process.env.MINISITO_RISCHI_LABEL_EN:
                return process.env.MINISITO_RISCHI_LABEL;
            case process.env.MINISITO_VOLONTARIATO_LABEL_EN:
                return process.env.MINISITO_VOLONTARIATO_LABEL;
            case process.env.MINISITO_DOMANDE_E_RISPOSTE_LABEL_EN:
                return process.env.MINISITO_DOMANDE_E_RISPOSTE_LABEL;
            case process.env.MINISITO_FORMAZIONE_LABEL_EN:
                return process.env.MINISITO_FORMAZIONE_LABEL;
            case process.env.MINISITO_MAPPE_LABEL_EN:
                return process.env.MINISITO_MAPPE_LABEL;
            case process.env.MINISITO_EVENTI_LABEL_EN:
                return process.env.MINISITO_EVENTI_LABEL;
            case process.env.MINISITO_RELAZIONI_INTERNAZIONALI_LABEL_EN:
                return process.env.MINISITO_RELAZIONI_INTERNAZIONALI_LABEL;
            case process.env.MINISITO_CAPRISCHIO_21_27_LABEL_EN:
                return process.env.MINISITO_CAPRISCHIO_21_27_LABEL;
            case process.env.MINISITO_SERVIZIO_NAZIONALE_LABEL_EN:
                return process.env.MINISITO_SERVIZIO_NAZIONALE_LABEL;
            case process.env.MINISITO_ATTUAZIONE_MISURE_PNRR_LABEL_EN:
                return process.env.MINISITO_ATTUAZIONE_MISURE_PNRR_LABEL;
            default:
                return "";

        }
    }

    getSuperheader = (menuItems, minisiti, basePath, lang) => {
        let superHeader
        if (menuItems && Array.isArray(menuItems)) {
            superHeader = menuItems.find(el => el.field_check_superheader);
            if(superHeader) {
                const baseURL = basePath
                    ? basePath
                    : (superHeader.node?.relationships?.field_link_menu?.relationships?.field_sottodominio
                        ? minisiti
                            ? minisiti[`MINISITO_${superHeader.node.relationships.field_link_menu.relationships.field_sottodominio.name.toUpperCase().replace(new RegExp("[\\s-]+", "g"), '_')}_URL`]
                            : ''
                        : '');
                let link = `${baseURL}${lang ? "/" + lang : ''}${superHeader.node.relationships.field_link_menu && superHeader.node.relationships.field_link_menu.fields ? superHeader.node.relationships.field_link_menu.fields.slug : ''}`;
                return {
                    id: superHeader.node.drupal_internal__tid,
                    link,
                    idContenuto: superHeader.node.relationships.field_link_menu ? superHeader.node.relationships.field_link_menu.drupal_internal__nid : null,
                    title: superHeader.node.name ? superHeader.node.name : '',
                }
            }
        }
    }

    render() {
        return (
            <>
                {/*<div>{this.getSuperheader(this.props.menuItems, this.props.minisiti, this.props.basePathNavbar, this.props.lang)?.title}</div>*/}
                <header
                    className={`it-header-wrapper it-header-sticky it-shadow`}
                    role="banner"
                    id={"header-dpc"}>
                    <GoogleAnalytics trackingId="G-WBL8W0C85T" />
                    <GoogleTagManager />
                    <LanguageButtonDPC slugTraduzione={this.props.slugTraduzione} env={this.props.env}
                                       lang={this.props.lang} superHeader={this.getSuperheader(this.props.menuItems, this.props.minisiti, this.props.basePathNavbar, this.props.lang)}/>
                    <div className="it-nav-wrapper">
                        <div className="it-header-center-wrapper">
                            <div className="container">
                                <div className="it-header-center-content-wrapper">
                                    <div className="it-brand-wrapper">
                                        <ul className="list-inline">
                                            <li className="list-inline-item">
                                                <a href={this.getHomePath()}
                                                   className="navbar-brand" title="Io non rischio">
                                                    <img src={LogoSVG} alt={"Logo di io non rischio"}/>
                                                </a>
                                            </li>
                                        </ul>
                                        <div className='sr-only'>
                                            <h2>{this.props.lang === 'it' ?
                                                "Io non rischio"
                                                :
                                                "Io non rischio"
                                            }
                                            </h2>
                                            <h3>{this.props.lang === 'it' ? 'Buone pratiche di Protezione Civile' : 'Presidency  of the Council of Ministers'}</h3>
                                        </div>
                                    </div>
                                    <div className="it-right-zone">
                                        <div className="it-search-wrapper">
                                            <form id="searchFormHeader" role="search" onSubmit={this.handleSubmit}>
                                                <label htmlFor="searchQueryHeader" className="sr-only">Cerca nel sito</label>
                                                <input type="text" id="searchQueryHeader" name="searchQueryHeader" placeholder="Cerca nel sito..."
                                                       onChange={this.handleInputChange} value={this.state.value}/>
                                                <button type="submit" className="search-link-customD rounded-icon" id="searchSubmitHeaderDesk">
                                                    <SvgIconDPC name={'fa-search'}/>
                                                </button>
                                                <button type="button" className="search-link-custom rounded-icon" id="switchSearchMobile">
                                                    <SvgIconDPC name={'fa-search'}/>
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                        </div>
                        <div className="it-header-search-input-wrapper d-none">
                            <div className="container">
                                <div className="px-custom">
                                    <form onSubmit={this.handleSubmit} id="searchFormHeaderM" role="search">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <label for="searchQueryHeaderMobile" className="sr-only active">Inserisci
                                                    parola chiave</label>
                                                <input type="text" className="form-control" id="searchQueryHeaderMobile"
                                                    name="searchQueryHeader"
                                                    placeholder="Inserisci parola chiave" onChange={this.handleInputChange} value={this.state.value}/>
                                                <div className="input-group-append">
                                                    <button type="submit" id="searchButtonHeaderMobile" className="btn">Cerca</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <NavbarDPC menuItems={this.getMenu(this.props.menuItems)} lang={this.props.lang}/>
                    </div>
                </header>
            </>
            )
    }
};
